'use strict';

import { Plugin } from 'mggp-player';
import debounce from 'lodash.debounce';
import { isPipAvailable } from './checkAvailability';

/**
 * @class MggpPluginPip
 */
export default class MggpPluginPip extends Plugin {
  constructor(...params) {
    super(...params);

    const videoInstances = this.player.get('videoInstances');

    this.videoElement = null;
    this.pipWindow = null;
    this.debouncedOnPipWindowResize = debounce(this.onPipWindowResize, 1000, {
      trailing: true,
      leading: false,
    });
    this.player.registerProperty('pip:pipIsSupported', false, true);

    if (videoInstances) {
      this.onVideoInstances({ data: videoInstances });
    } else {
      this.player.on('property:videoInstances', this.onVideoInstances);
    }
  }

  onVideoInstances = ({ data }) => {
    this.player.off('property:videoInstances', this.onVideoInstances);
    this.videoElement = data.find((item) =>
      item.classList.contains('player:video'),
    );

    if (
      isPipAvailable({ player: this.player, videoElement: this.videoElement })
    ) {
      this.player.set('pip:pipIsSupported', true);
      this.subscribeOnEvent(true);
    }
  };

  subscribeOnEvent = () => {
    this.player.on('pip:pipButtonClick', this.onPlayerPipButtonClick);
    if (this.videoElement) {
      this.videoElement.addEventListener(
        'enterpictureinpicture',
        this.onEnterPip,
      );
      this.videoElement.addEventListener(
        'leavepictureinpicture',
        this.onLeavePip,
      );
    }
  };

  onPlayerPipButtonClick = () => {
    if (document.pictureInPictureElement) {
      document.exitPictureInPicture().catch((error) => {
        console.error(error);
        this.player.emit('pip:error', `Exit error: ${error.toString()}`);
      });
    } else {
      this.videoElement.requestPictureInPicture().catch((error) => {
        console.error(error);
        this.player.emit('pip:error', `Enter error: ${error.toString()}`);
      });
    }

    if (document.fullscreenElement === this.player.config.container) {
      document.exitFullscreen();
    }
  };

  onEnterPip = (event) => {
    this.pipWindow = event.pictureInPictureWindow;
    this.pipWindow.addEventListener('resize', this.debouncedOnPipWindowResize);
    this.videoElement.addEventListener('pause', this.onVideoPause);
    this.videoElement.addEventListener('playing', this.onVideoPlay);
    this.player.set('pip:isPipModeOn', true);
  };

  onVideoPlay = () => {
    if (this.player.get('state') !== 1) this.player.set('state', 1);
  };

  onVideoPause = () => {
    if (this.player.get('state') !== 2) {
      this.player.set('state', 1); //MHP-2169 Test 2 (fb) : Ah ;(
      this.player.set('state', 2);
    }
  };

  onLeavePip = () => {
    const playerState = this.player.get('state');

    if (playerState === 1) {
      this.player.play();
      setTimeout(() => {
        // MHP-2169
        if (this.videoElement.paused) this.player.play();
      }, 300);
    } else if (playerState === 5) {
      this.player.emit('pip:leavePipOnPause');
    }
    this.player.set('pip:isPipModeOn', false);
    this.pipWindow?.removeEventListener(
      'resize',
      this.debouncedOnPipWindowResize,
    );

    this.videoElement.removeEventListener('pause', this.onVideoPause);
    this.videoElement.removeEventListener('playing', this.onVideoPlay);
  };

  onPipWindowResize = (event) => {
    const { width, height } = event.currentTarget;
    this.player.emit('pip:resize', { width, height });
  };
}
